<template>
  <validation-provider
    :mode="mode"
    ref="valProv"
    tag="div"
    :vid="vid"
    :rules="rules"
    v-slot="{ errors, passed: inputValid }"
    :name="getLabel">
    <z-field :message="errors[0]" :type="{ danger: errors[0], success: inputValid && showSuccessField }">
      <div :class="{ 'flex items-center': horizontal }">
        <label
          :for="'cc' + $uuid()"
          class="text-sm font-medium block"
          :class="{ 'flex items-center me-3': horizontal, 'required' :isRequired }">
          {{ getLabel }}
          <slot name="label" />
        </label>
        <div class="relative">
          <div class="flex items-center">
            <span
              v-if="prefix"
              class="absolute start-2 font-bold text-secondary text-base py-2.5 mt-1">
              {{ prefix }}
            </span>
            <span
              v-if="suffix"
              class="absolute end-2 font-bold text-secondary text-base py-2.5 mt-1">
              {{ suffix }}
            </span>
            <input
              v-if="inputType !== 'textarea'"
              :dir="direction"
              :id="'cc' + $uuid()"
              :placeholder="placeholder"
              :name="getLabel"
              v-bind="$attrs"
              v-model="localValue"
              @blur="onBlur"
              :style="inputStyle"
              :type="inputType"
              :class="[classes, inputClasses]" />
            <textarea
              v-else
              :dir="direction"
              v-model="localValue"
              :class="[classes, inputClasses]" />
            <div class="absolute end-2 items-end">
              <!--        <span v-if="this.getType === 'danger'" class="icon-Info text-danger"></span>-->
              <!--        <span v-else-if="this.getType === 'success'" class="icon-check-mark-button text-green"></span>-->
              <slot name="right" />
            </div>
          </div>
        </div>
      </div>
    </z-field>
  </validation-provider>
</template>

<script>
import formMixin from '../utils/mixins/formMixin'
import { ValidationProvider } from 'vee-validate'
import ZField from './ZField'

export default {
  name: 'ZInputWithValidation',
  components: { ZField, ValidationProvider },
  inheritAttrs: false,
  mixins: [formMixin],
  props: {
    direction: {
      type: String,
      default: ''
    },
    value: [String, Number],
    outlined: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: [String,Number],
      default: 'text'
    },
    placeholder: {
      type: String
    },
    inputClasses: String,
    inputStyle: String,
    prefix: String,
    suffix: String,
    horizontal: Boolean,
    rules: {
      type: [Object, String],
      default: ''
    },
    vid: {
      type: String,
      default: undefined
    },
    validateOnLength: {
      type: [Number, Boolean],
      default: false
    },
    mode:{
      type:String,
      default:'passive'
    },
    showSuccessField: {
      type: Boolean,
      default: true
    },
    isNoValidationSameValueMode: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    classes() {
      return [
        {
          'bg-gray-100 border rounded-md': !this.outlined && !this.borderless,
          'border-primary border-b border-t-0 border-l-0 border-r-0':
            this.outlined && !this.borderless,
          'bg-white text-primary border-0': this.borderless
        },
        { 'cursor-not-allowed': this.$attrs.disabled === '' || this.$attrs.disabled },
        { 'border border-gray-200 dark:border-gray-500': !this.borderless },
        'mt-1 w-full',
        'py-2.5 dark:bg-gray-600 dark:placeholder-gray-400 dark:text-white focus:border-transparent focus:outline-none',
        'focus:ring focus:ring-blue-200 focus:border-blue-400',
        {
          'border-danger': this.getType === 'danger',
          'border-green': this.getType === 'success'
        },
        {
          'ps-10 text-left': this.prefix,
          'pe-10 text-left': this.suffix
        },
        {
          'pe-7 text-start': this.hasRightSlot
        }
      ]
    },
    hasRightSlot() {
      return !!this.$scopedSlots.right
    },
    isRequired() {
      if (typeof this.rules === 'string') {
        return this.rules.includes('required')
      } else {
        return this.rules?.required
      }
    }
  },
  data() {
    return {
      originalValue: this.value,
      localValue: this.value,
      id: 0
    }
  },
  watch: {
    localValue(val) {
      this.$emit('input', val)
      if (this.validateOnLength && (val?.toString()?.length === this.validateOnLength))
        this.$refs.valProv.validate()
    },
    value(val) {
      this.localValue = val
    }
  },
  beforeMount() {
    this.id = this.$uuid()
  },
  methods: {

    async onBlur(){
      if (this.isNoValidationSameValueMode) {
        if (this.localValue !== this.originalValue) {
          this.$emit('blur', (await this.$refs.valProv.validate()).valid)
        }
      } else {
        this.$emit('blur', (await this.$refs.valProv.validate()).valid)
      }
    }
  }
}
</script>

<style scoped>
[dir='rtl'] label input {
  text-align: right !important;
}

.required:after {
  content:" *";
  color: #d12b8a;
}
</style>
